import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Question } from 'src/interfaces/questions/question';
import { PageBlockFormQuestionComponent } from '../page-block-form-question.component';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { ValidationService } from 'src/app/services/validation.service';
import { Entrant } from 'src/interfaces/entrants/entrant';

@Component({
    selector: 'app-page-block-form-question-bot',
    templateUrl: './page-block-form-question-bot.component.html',
    styleUrls: ['./page-block-form-question-bot.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageBlockFormQuestionBotComponent implements OnInit, OnDestroy {
    @Input() formGroup!: FormGroup;
    @Input() question!: Question;
    @Input() entrant?: Entrant;
    @Input() controller?: PageBlockFormQuestionComponent;

    controlName: string = this.question?.key;
    control: FormControl = this.formBuilder?.control('', []);

    constructor(private formBuilder: FormBuilder, public Validation: ValidationService) {
    }

    ngOnInit(): void {
        this.controlName = this.question.key;

        this.setValidation();
        this.Validation.setCustomValidation(this.question, this.question.options.validations, this.control);
    }

    setValidation(): void {
        this.formGroup.addControl(this.controlName, this.control);

        setTimeout(() => {
            if (this.entrant && this.entrant?.answers) {
                this.control.setValue(this.entrant?.answers[this.question.key]);
            } else {
                if (this.question.options.values?.find(option => option.default === true)) {
                    const defaultOption = this.question.options.values.find(option => option.default === true);
                    if (defaultOption?.value) {
                        this.control.setValue(defaultOption?.value);
                    }
                }
            }
        }, 250);
    }

    ngOnDestroy(): void {
        this.formGroup.removeControl(this.controlName);
    }
}
